import { render, staticRenderFns } from "./RowIndicadores.vue?vue&type=template&id=12b3c408&scoped=true"
import script from "./RowIndicadores.vue?vue&type=script&lang=js"
export * from "./RowIndicadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3c408",
  null
  
)

export default component.exports